module.exports = __webpack_public_path__ + "img/img-2.329e1b53.svg";